export enum SpecialtyAnalyticsEnum {
  VIEW_SPECIALTIES_INDEX_PAGE = '[PAC WEB] Índice de Especialidades - Página visualizada',

  EXPAND_SPECIALTY = '[PAC WEB] Índice de Especialidades - Expandiu especialidade',
  EXPAND_STATE_UF = '[PAC WEB] Índice de Especialidades - Expandiu estado (UF)',

  CLICK_SPECIALTY_BY_CITY = '[PAC WEB] Índice de Especialidades - Clicou em especialidade por cidade',

  CLICK_SEE_ALL = '[PAC WEB] Índice de Especialidades - Clicou em "Ver todas"',
  CLICK_SEE_MORE_BY_SPECIALTY = '[PAC WEB] Índice de Especialidades - Clicou em "Ver mais" por especialidade',
  CLICK_SEE_MORE_BY_SPECIALTY_AND_UF = '[PAC WEB] Índice de Especialidades - Clicou em "Ver mais" por especialidade e UF',

  CLICK_CTA_SCHEDULE_SPECIALTY_BY_WEBSITE = '[PAC WEB] Índice de Especialidades - Clicou em "Agendar pelo site"',
  CLICK_CTA_SCHEDULE_SPECIALTY_BY_SUPPORT = '[PAC WEB] Índice de Especialidades - Clicou em "Agendar com atendente"',
  CLICK_CTA_SCHEDULE_SPECIALTY_BY_TELEHEALTH = '[PAC WEB] Índice de Especialidades - Clicou em "Agendar teleconsulta"',
}
